export const HEADER_HEIGHT_PX = '134px'
export const CAROUSEL_ITEM_HEIGHT_PX = '54px'
export const FILTER_COUNT_SIZE_PX = '22px'
export const FILTERS_MENU_BUTTON_HEIGHT_PX = '44px'
export const MAX_APPLIED_FILTERS_TO_SHOW_NBAS = 8
